<template>
  <v-container
    class="pa-0 mt-md-2"
  >
    <v-toolbar
      flat
    >
      <v-btn
        icon
        to="/eleave/list"
      >
        <v-icon>{{ mdiArrowLeft }}</v-icon>
      </v-btn>
      <v-toolbar-title>
        {{ $t('eLeave.AllAppliedLeave') }}
      </v-toolbar-title>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="approvedLeaves"
      :footer-props="{
        disableItemsPerPage: true
      }"
      class="v-data-footer__select-hide v-data-table--sm-dense"
    >
      <template v-slot:item.appStatus="{ item }">
        <span :class="appStatusClass(item)">
          {{ $t(item.appStatus) }}
        </span>
      </template>
      <template v-slot:item.refFormCode="{ item }">
        <v-btn
          v-if="$config.isBrowser && showDownloadButton(item.refFormCode)"
          icon
          large
          class="float-right"
          :loading="downloadLoading"
          @click="downloadFile(item.refFormCode)"
        >
          <v-icon color="deep-orange lighten-2">
            {{ mdiFileDownloadOutline }}
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <span class="text-caption grey--text">{{ $t('eLeave.RecentXYearRecords', {'0': '2'}) }}</span>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { eLeaveModule } from '../../store/moduleName'
import { appStatusClassMixin } from './mixins/appStatusClassMixin'
import { mdiArrowLeft, mdiFileDownloadOutline } from '@mdi/js'
import { eLeaveMethod } from '@/views/Eleave/mixins/eLeaveMethod'

export default {
  components: {
  },
  mixins: [appStatusClassMixin, eLeaveMethod],
  data: function () {
    return {
      mdiArrowLeft: mdiArrowLeft,
      mdiFileDownloadOutline: mdiFileDownloadOutline,
      headers: [
        {
          text: this.$t('Text.Date'),
          value: 'period'
        },
        {
          text: this.$t('Text.NumberOfDays'),
          value: 'numDaysManual'
        },
        {
          text: this.$t('eLeave.appStatus'),
          value: this.$chPtField('chinAbsentTypeDesc')
        },
        {
          text: this.$t('Text.Status'),
          value: 'appStatus'
        },
        {
          text: '',
          value: 'refFormCode'
        }
      ],
      downloadLoading: false
      // approvedLeaves: [
      //   {
      //     date: '2019-10-25 ~ 2019-10-25',
      //     days: 1,
      //     leaveType: '年假',
      //     status: '批淮'
      //   },
      //   {
      //     date: '2019-10-12 ~ 2019-10-22',
      //     days: 10,
      //     leaveType: '長年假',
      //     status: '取消'
      //   }
      // ]
    }
  },
  computed: {
    ...mapState({
      approvedLeaves: state => state[eLeaveModule].feriasRecords
    })
  },
  created () {
    this.$store.dispatch(eLeaveModule + '/getFeriasRecords', 1) // show recednt two years record
    // this.$store.dispatch(eLeaveModule + '/getFeriasRecordsThisYear')
    // this.$store.dispatch(coursesModule + '/getProposalFormReportByYear', ~~year)
    // this.getProposalByYear(year)
  }
}
</script>
